import { getStaticCdnUrl } from '@/utils';

export const INVITE_OG_IMAGE_URL = getStaticCdnUrl('invite/og.png');

export const INVITE_SHARE_CONTENT = {
  title: '친구초대하고 모두 1,000원씩!',
  description: '웰로를 소개하고 기부하면 웰포인트를 드려요!',
  imageUrl: getStaticCdnUrl('invite/kakao-share.png'),
};
